import { updatePriceCalculation } from '../../../helpers/building_pricing/buildingPricing.helper';
import { params, const_var} from '../reducer';
import * as cuBuilding from './pricingReducer';
export const priceUpdateState = {
	changePriceCalculation:'',
	UpdatedPriceData:'',
	PriceData:'',
	updateEditBox:false,
}
priceUpdateState.UpdatedPriceData = const_var.UpdatedPriceData;
const priceUpdateReducer = (state = priceUpdateState,action) =>
{
	const newState = {...state};
	switch (action.type)
	{
		case "updatePriceCalculation":
			if(action.key=="entry_price")
			{
				state.updateEditBox = !state.updateEditBox;	
			}
            updatePriceCalculation(action.newVal,action.oldVal,action.key,action.leanVal,action.objIndex,action.uniqueId, action.elementObjIndex,action.extraItemType,action.cupolaId, action.anchor);
            state.PriceData = const_var.post_data.building;
        return{
            ...state,
            changePriceCalculation:action
        }
	}
	return newState;
}
export default priceUpdateReducer;